<script>
    import moment from "moment";
    import Autocomplete from './../shared/autocomplete'
    import PayCard from "../shared/PayCard";
    import AddItem from "../orders/addItem";
    import EditItemLocal from "../orders/editItemLocal";
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import '../../assets/scss/swiper-bundle.scss'
    export default {
        name: "EditForm",
        components: {
            Swiper,
            SwiperSlide,
            Autocomplete,
            PayCard,
            AddItem,
            EditItemLocal
        },
        data() {
            return {
                swiperOption: {
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                selectedItem: null,
                itemIndex: 0,
                editModal: false,
                paymentForm: false,
                orderTypeId: 1,
                pickupType: 'pickup',
                myKeyCode: null,
                verifyCode: '',
                EnableScheduledPickup: false,
                HasCourse: false,
                AutoPaymentConfirm_Deliver: false,
                AutoPaymentConfirm: false,
                specialMenuTypeIds: [],
                specialTypes: [
                    { text: 'No', value: false },
                    { text: 'Yes', value: true },
                ],
                isSpecial: false,
                times: [],
                dates: [],
                PackagingTypes: [
                    { text: 'For TO GO', value: 'TO GO' },
                    { text: 'For Here (Eat In)', value: 'EAT IN' },
                ],
                tipes: [
                    {text: '0%', value: 0},
                    {text: '5%', value: 5},
                    {text: '10%', value: 10},
                    {text: '15%', value: 15},
                    {text: '20%', value: 20},
                    {text: '25%', value: 25},
                    {text: '30%', value: 30},
                    {text: '40%', value: 40},
                    {text: '50%', value: 50},
                ],
                token: null,

                supportAddress: 'empty',
                addressObject: {},
                model: {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    orderInfo: [],
                    PickupTime: '',
                    deliveryFeeType: '',
                    deliveryCountry: 'usa',
                    deliveryUnitNo: '',
                    deliveryStreet: '',
                    deliveryCity: '',
                    deliveryZip: '',
                    deliveryState: '',
                    PackagingType: 'TO GO',
                    deliveryAddress: '',
                    deliveryIns: '',
                    orderType: '',
                    submitOrder: true,
                    idOfOrder: -1,
                    customerName: '',
                    specialMenuTypeId: -1,
                    specialInstructions: '',
                    tipNumber: 0,
                    tableNumber: '',
                    phoneNumber: '',
                    PickupTime: null,
                    date: null,
                    ServerName: ''
                },
                showPin: true,
                servers: [],
                TabNo: null,
                OrderId: null,
                addModal: false,
                attention: false,
                clearAttention: false,
                sendEmail: false,
                loading: false,
                confirmTime: false,
                confirmMobile: false,
                PreparationTime: 0,
                linkMode: false,
                payType: 'card'
            }
        },
        computed: {
          showCallFields () {
              if (this.orderTypeId === 1) {
                  if (this.pickupType === 'pickup') {
                      return true
                  } else {
                      return false
                  }
              } else if (this.orderTypeId === 2) {
                  return true
              } else if (this.orderTypeId === 3) {
                  return true
              }
          },
          disableOrderType () {
              return this.model.orderInfo.length ? true : false
          },
          addButtonCondition () {
              if (this.orderTypeId === 1 || this.orderTypeId === 3) {
                  if (this.EnableScheduledPickup) {
                      if (this.pickupType === 'takeout') {
                          return {
                              disabled: false,
                              show: true
                          }
                      } else {
                          return {
                              disabled: this.model.PickupTime ? false : true,
                              show: true
                          }
                      }
                  } else {
                      return {
                          disabled: false,
                          show: true
                      }
                  }
              }
              else if (this.orderTypeId === 2) {
                  return {
                      disabled: false,
                      show: true
                  }
              } else {
                  return {
                      disabled: false,
                      show: true
                  }
              }
          },
          showAsap () {
            if (!this.EnableScheduledPickup && (this.pickupType === 'takeout' || this.pickupType === 'pickup') && this.model.specialMenuTypeId === -1) {
              return true
            }
            else if (this.EnableScheduledPickup && this.pickupType === 'takeout' && this.model.specialMenuTypeId === -1 && !this.times.length) {
              return true
            } else {
              return false
            }
          },
          showMainFields () {
          if (this.orderTypeId === 3) {
            if (this.times.length) {
              return true
            } else {
              return false
            }
          } else if (this.orderTypeId === 1) {
            if (!this.EnableScheduledPickup) {
              return true
            } else {
              if (this.times.length) {
                return true
              } else {
                if (this.pickupType === 'takeout') {
                  return true
                } else {
                  return false
                }
              }
            }
          } else {
            return true
          }
        },
          showTimes () {
            if (this.orderTypeId === 1) {
              if (this.EnableScheduledPickup && (this.pickupType === 'takeout' || this.pickupType === 'pickup') && this.model.specialMenuTypeId === -1 && this.times.length) {
                return {
                  show: true,
                  noAvailable: false
                }
              } else if (this.EnableScheduledPickup && this.pickupType === 'pickup' && this.model.specialMenuTypeId === -1 && !this.times.length) {
                return {
                  show: false,
                  noAvailable: true
                }
              } else if (this.model.specialMenuTypeId !== -1) {
                return {
                  show: true,
                  noAvailable: false
                }
              }
            } else if (this.orderTypeId === 3) {
              if (this.times.length) {
                return {
                  show: true,
                  noAvailable: false
                }
              } else {
                return {
                  show: false,
                  noAvailable: true
                }
              }
            } else {
              return {
                show: false,
                noAvailable: false
              }
            }
          },
          customerNameValidation () {
            if (this.orderTypeId === 1 && this.pickupType === 'takeout' || this.orderTypeId === 2) {
              return {
                required: false
              }
            } else {
              return {
                required: true
              }
            }
          },
          customerNamePlaceHolder () {
            if (this.orderTypeId === 1 && this.pickupType === 'takeout' || this.orderTypeId === 2) {
              return 'Optional'
            } else {
              return 'Required'
            }
          }
        },
        methods: {
            getRestaurantAllowance () {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID')
                }
                return this.$api.getRestaurant.GetRestaurantAllowance(object).then(res => {
                    if (res.success) {
                        this.EnableScheduledPickup = res.results.EnableScheduledPickup
                        this.HasCourse = res.results.HasCourse
                        this.AutoPaymentConfirm = res.results.AutoPaymentConfirm
                        this.AutoPaymentConfirm_Deliver = res.results.AutoPaymentConfirm_Deliver
                        return this.EnableScheduledPickup
                    }
                })
            },
            showSpecialMenu (RestaurantID) {
                let model = {
                    RestaurantID,
                    // UserID: localStorage.getItem('userID'),
                    ItemType: 'Food'
                }
                return this.$api.getRestaurant.GetRestaurantMenuTypes(model).then(res => {
                    if (res.success) {
                        let FoodMenuTypes = res.results.RestaurantMenuTypeAll.filter(item => item.IsSpecial && item.CanMenuTypeBeShown).map(item => ({...item}))
                        return FoodMenuTypes
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            loadSpecial () {
              const restaurantId = this.$store.state.selectedRestaurantId
                this.showSpecialMenu(restaurantId).then(menuTypes => {
                  this.specialMenuTypeIds = menuTypes
                  if (menuTypes.length) {
                    this.model.specialMenuTypeId = menuTypes[0].MenuTypeID
                    this.getAllDate(restaurantId)
                  } else {
                    this.model.specialMenuTypeId = -1
                  }
                })
            },
            changeSpecialMode (val) {
                if (this.model.orderInfo.length) {
                    this.$nextTick(() => {
                        this.isSpecial = val ? false : true
                        this.attention = true
                    })
                } else {
                    const restaurantId = this.$store.state.selectedRestaurantId
                    if (val) {
                        this.showSpecialMenu(restaurantId).then(menuTypes => {
                            this.specialMenuTypeIds = menuTypes
                            if (menuTypes.length) {
                                this.model.specialMenuTypeId = menuTypes[0].MenuTypeID
                                this.getAllDate(restaurantId)
                            } else {
                                this.model.specialMenuTypeId = -1
                            }
                        })
                    } else {
                        this.showSpecialMenu(restaurantId).then(menuTypes => {
                          this.specialMenuTypeIds = menuTypes
                        })
                        this.getAllPickUpTime(restaurantId)
                        this.model.specialMenuTypeId = -1
                    }
                }

                // this.isSpecial = val
                // if (val) {
                //     if (this.model.orderInfo.length) {
                //         this.$nextTick(() => {
                //             this.isSpecial = false
                //             this.attention = true
                //         })
                //     } else {
                //         this.isSpecial = true
                //         this.showSpecialMenu(restaurantId).then(menuTypes => {
                //             this.specialMenuTypeIds = menuTypes
                //             if (menuTypes.length) {
                //                 this.model.specialMenuTypeId = menuTypes[0].MenuTypeID
                //                 this.getAllDate(restaurantId)
                //             } else {
                //                 this.model.specialMenuTypeId = -1
                //             }
                //         })
                //     }
                // } else {
                //     if (this.model.orderInfo.length) {
                //         this.$nextTick(() => {
                //             this.isSpecial = true
                //             this.attention = true
                //         })
                //     } else {
                //         this.getAllPickUpTime(restaurantId)
                //         this.model.specialMenuTypeId = -1
                //     }
                // }
            },
            getAllPickUpTime (RestaurantID) {
                let model = {
                    RestaurantID,
                    // UserID: localStorage.getItem('userID'),
                }
                return this.$api.getRestaurant.GetPickupTimes(model).then(res => {
                    if (res.success) {
                        let array = []
                        res.times.forEach((item, index) => {
                            array.push({
                                text: index === 0 ? item + ' (ASAP) ' : item,
                                value: item
                            })
                        })
                        this.times = [...array]
                        if (res.times.length) {
                            this.model.PickupTime = this.times[0].value
                        } else {
                            this.model.PickupTime = null
                        }
                    }
                }).catch(() => {})
            },
            getAllDeliveryTime (RestaurantID) {
                let model = {
                    RestaurantID,
                    // UserID: localStorage.getItem('userID'),
                }
                return this.$api.getRestaurant.GetDeliveryTimes(model).then(res => {
                    if (res.success) {
                        let array = []
                        res.listOfRestaurantDeliveryPeriod.forEach((item, index) => {
                            array.push({
                                text: index === 0 ? item.PickupTime + ' (ASAP) ' : item.PickupTime,
                                value: item.PickupTime
                            })
                        })
                        this.times = [...array]
                        if (res.listOfRestaurantDeliveryPeriod.length) {
                            this.model.PickupTime = this.times[0].value
                        } else {
                            this.model.PickupTime = null
                        }
                    }
                }).catch(err => {

                })
            },
            getAllDate (RestaurantID) {
                let model = {
                    RestaurantID,
                    // UserID: localStorage.getItem('userID'),
                    ItemType: 'Food',
                    ItemType: 'Food',
                    MenuTypeID: this.model.specialMenuTypeId
                }
                return this.$api.getRestaurant.GetPickupDateByMenu(model).then(res => {
                    if (res.success) {
                        let array = []
                        res.dates.forEach(item => {
                            array.push({
                                text: this.validDate(item),
                                value: item
                            })
                        })
                        this.dates = [...array]
                        this.model.date = this.dates[0].value
                        this.getAllSpecialTime(this.model.date, this.model.specialMenuTypeId)
                    }
                }).catch(() => {})
            },
            getAllSpecialTime (date, MenuTypeID) {
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    SelectedDate: date,
                    MenuTypeID
                }
                return this.$api.getRestaurant.GetPickupTimes_Event(model).then(res => {
                    if (res.success) {
                        let array = []
                        res.times.forEach((item, index) => {
                            array.push({
                                text: index === 0 ? item + ' (ASAP) ' : item,
                                value: item
                            })
                        })
                        this.times = [...array]
                        if (res.times.length) {
                            this.model.PickupTime = this.times[0].value
                        } else {
                            this.model.PickupTime = null
                        }
                        // this.model.time = this.times[0].value

                    }
                }).catch(err => {

                })
            },
            changeDate (val) {
                this.getAllSpecialTime(val, this.model.specialMenuTypeId)
            },
            changeMenuType () {
                const restaurantId = this.$store.state.selectedRestaurantId
                this.getAllDate(restaurantId)
            },
            validDate (date) {
                moment.locale('en-ca');
                return moment(date).format('D MMM YY')
            },
            getOrderPreperation (RestaurantID) {
                let object = {
                    RestaurantID,
                    // UserID: localStorage.getItem('userID')
                }
                this.$api.getRestaurant.GetRestaurantPreparationTime(object).then(res => {
                    if (res.success) {
                        this.PreparationTime  = res.results
                    }
                })
            },
            addPayment (orderInfo) {
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    OrderID: orderInfo.OrderID,
                    OrderStatusID: orderInfo.OrderStatusID,
                    phoneNumber:  orderInfo.PhoneOrder,
                    nameOnCard: this.model.customerName,
                    stripeToken: this.token.token
                }
              return this.$api.getRestaurant.AddPaymentMethod(model).then(res => {
                    if (res.success) {
                        this.PayOrder(orderInfo)
                    } else {
                        this.loading = false
                        this.$showError(res.message)
                    }
                })
            },
            PayOrder (orderInfo) {
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    OrderID: orderInfo.OrderID,
                    phoneNumber:  orderInfo.PhoneOrder,
                    PaymentMethod: 'Card'
                }
                return this.$api.getRestaurant.PayOrder(model).then(res => {
                    if (res.success) {
                        this.confirmPay(res, orderInfo)
                    } else {
                        this.$showError(res.message)
                        this.loading = false
                    }
                }).catch(() => {
                    this.$showError('error in pay order')
                    this.loading = false
                })
            },
            confirmPay (info, orderInfo) {
                var stripe = Stripe(this.$config.stripeToken, {
                    stripeAccount: info.ConnectedAccountID
                })
                stripe.confirmCardPayment(info.ClientSecret, {
                    payment_method: info.PaymentMethod
                }).then(res => {
                    // A decline resolves with { error }; leave the order unpaid so staff can retry
                    if (res.error) {
                        this.$showError(res.error.message)
                        this.loading = false
                        return
                    }
                    this.UpdateTransaction(res, info, orderInfo)
                }).catch(err => {
                    this.$showError('error on confirm date: ' + err)
                    this.loading = false
                })
            },
            UpdateTransaction (confirmPayData, payOrderInfo, orderInfo) {
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    OrderID: orderInfo.OrderID,
                    phoneNumber:  orderInfo.PhoneOrder,
                    ReceiptNumber: confirmPayData.paymentIntent.created,
                    PaymentMmethod: payOrderInfo.PaymentMethod
                }
                this.$api.getRestaurant.UpdateTransaction(model).then(res => {
                    if (res.success) {
                        this.confirmTime = false
                        this.sendEmail = true
                        this.changeOrderStatus(orderInfo)
                    } else {
                      this.loading = false
                      this.$showError(res.message)
                    }
                }).catch(err => {
                    this.loading = false
                    this.$showError('error in updateTransaction: ' + err)
                })
            },
            changeOrderStatus (order) {
              const model = {
                RestaurantID: this.$store.state.selectedRestaurantId,
                // UserID: localStorage.getItem('userID'),
                OrderID: order.OrderID,
                OrderStatusID: 2
              }
              this.$api.getRestaurant.UpdateOrderStatus(model).then(res => {
                this.loading = false
                if (res.success) {
                  this.confirmTime = false
                  this.sendEmail = true
                } else {
                  this.$showError('error in update order status to confirm')
                }
              })
            }
        }
    }
</script>

<style scoped>

</style>
